import { render, staticRenderFns } from "./RejectRegularizationModal.vue?vue&type=template&id=1c50d9b9&"
import script from "./RejectRegularizationModal.vue?vue&type=script&lang=js&"
export * from "./RejectRegularizationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports